<template>
  <div class="maintenanceBudget">
    <el-table
      empty-text="無進行中計畫"
      :data="maintenanceBudgetList"
      style="width: 100%"
    >
      <el-table-column
        v-for="[key, val] of Object.entries(maintenanceBudget)"
        :key="key"
        :prop="key"
        :label="val"
      >
        <template slot-scope="scope">
          {{ scope.row[key] === null ? '-' : scope.row[key] }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { apiAsset } from '../../../api/smartBuildingSystemAPI'
import { maintenanceBudget } from '../models'
export default {
  data () {
    return {
      maintenanceBudget,
      selectedYears: this.$route.params.selectedYears,
      maintenanceBudgetList: []
    }
  },
  watch: {
    $route (to, from) {
      this.selectedYears = to.params.selectedYears
      this.getBudget()
    }
  },
  mounted () {
    this.getBudget()
  },
  methods: {
    async getBudget () {
      const { data } = await apiAsset.maintenance.getCostEstimationMaintenance(this.selectedYears)
      data.forEach(el => {
        el.Categories = el.Categories.join('; ') || null
      })
      this.maintenanceBudgetList = data
    }
  }
}
</script>

<style lang="scss" scoped>
.maintenanceBudget {
    ::v-deep .el-table {
  @include basicTable();
}
}
</style>
